import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import DataAids from '../constants/data-aids';

class CustomArrows extends Component {
  render() {
    const { prevSlide, nextSlide, backgroundImage, category, section } = this.props;

    const arrowStyles = {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      fontColor: 'lowContrast',
      cursor: 'pointer',
      zIndex: '1'
    };

    const sectionProps = {
      section: backgroundImage ? 'overlay' : section,
      category: backgroundImage ? 'accent' : category
    };

    return (
      <UX2.Element.Block { ...sectionProps }>
        <UX2.Element.Icon
          style={{ ...arrowStyles, left: '-xlarge' }}
          onClick={ prevSlide }
          data-aid={ DataAids.RSS_SCROLL_LEFT_ARROW }
          icon='chevronLeft'
          size='large'
        />
        <UX2.Element.Icon
          style={{ ...arrowStyles, right: '-xlarge' }}
          onClick={ nextSlide }
          data-aid={ DataAids.RSS_SCROLL_RIGHT_ARROW }
          icon='chevronRight'
          size='large'
        />
      </UX2.Element.Block>
    );
  }
}

CustomArrows.propTypes = {
  prevSlide: PropTypes.func,
  nextSlide: PropTypes.func,
  backgroundImage: PropTypes.string,
  category: PropTypes.string,
  section: PropTypes.string
};

export default CustomArrows;
